<template>
  <KikDrawer title="Energy efficiency class">
    <template #button>
      <div class="flex items-center gap-3 border-t py-3 text-sm mobile:justify-between mobile:text-xs">
        <div class="flex items-center gap-3">
          <NuxtImg
            v-if="efficiencyIconUrl"
            :src="efficiencyIconUrl"
            :alt="$t('Energy Efficiency')"
            width="40"
            class="cursor-pointer"
          />
          {{ $t('Energy efficiency class') }}
        </div>
        <SfIconInfo
          class="min-w-6"
          size="base"
        />
      </div>
    </template>
    <template #content>
      <NuxtImg
        class="h-full"
        :src="efficiencyLabel"
        :alt="$t('Efficiency Label')"
      />
    </template>
  </KikDrawer>
</template>

<script lang="ts" setup>
import { SfIconInfo } from '@storefront-ui/vue';
import productGetters from '~/composables/getters/productGetters';

interface Props {
  product?: any;
  attributes?: any;
}

const props = defineProps<Props>();

const efficiencyLabel = computed<string>(() => props.product?.variants?.[0]?.attributes.energy_efficiency_label);
const efficiencyIconUrl = computed(() => productGetters.getEfficiencyIconUrl(props.attributes));
</script>
